import React from 'react';
import withIcon from '../utilities/withIcon';

const IconDanger = () => {
  return (
    <g>
      <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM2.904 3.965a6.5 6.5 0 0 0 9.131 9.131L2.904 3.965zM8 1.5a6.472 6.472 0 0 0-4.035 1.404l9.131 9.131A6.5 6.5 0 0 0 8 1.5z" />
    </g>
  );
};

export default withIcon(IconDanger);
